import finiture_finestre from '../assets/data.json';
import Pickr from '@simonwep/pickr';
import * as THREE from 'three';
import 'bootstrap';


let scene;
let config = {};
let zoomButtons = [];
let cameraControls;
const assetDir = './assets/'
const anteprimaDir = assetDir+'images/anteprima_finiture/';

const zoomable = [{
    name: 'maniglia',
    offset: {x: 10, y:0, z: 20}
},{
    name: 'cerniera_1',
    offset: {x: -6, y:0, z: 20}
},{
    name: 'cerniera_4',
    offset: {x: 10, y:0, z: 20}
},{
    name: 'maniglia',
    offset: {x: 0, y:0, z: 110}
},{
    name: 'cassonetto',
    offset: {x: -65, y:-2, z: 50}
}];

export const generateList = (data, container, callback, reset = true) => {
    let html = "";

    if(!reset) html = $(container).html().toString();

    if(reset){
        document.querySelectorAll(container+" .img-radio").forEach((el) => {
            el.removeEventListener('change');
        });
    }


    data.forEach((item) => {

       html += '<div class="col-6 col-sm-4 text-center image-radio"><label><input type="radio" class="img-radio" name="finitura" value="'+item.id+'" ><img class="img" src="'+anteprimaDir+item.anteprima_img+'" /></label><span>'+item.descrizione+'</span></div>';
     
    });	

    document.querySelector(container).innerHTML = html;

    document.querySelectorAll(container+" .img-radio").forEach((el) => {
        el.addEventListener('change', ()=>{
            callback(el.value);
            updateConfig();
        });
    });

};

export const updateConfig = () => {

    let finitura = config.finestra.descrizione;
    let fin_mazzetta = config.finestra.codice_mazzetta;
    let fin_prod = config.finestra.codice_produttore;

    let finestra = document.querySelector('.config-finestra');
    finestra.querySelector('.finitura span').innerHTML = finitura;
    finestra.querySelector('.cod-mazzetta span').innerHTML = fin_mazzetta;
    finestra.querySelector('.cod-produttore span').innerHTML = fin_prod;
    
    let cassonetto = document.querySelector('.config-cassonetto');
    let tipo_cassonetto = $(".cassonetto-select").val();

    cassonetto.querySelector('.visibile span').innerHTML = tipo_cassonetto == "2" ? "NO" : "SI";

    if(tipo_cassonetto == "1"){
        $(".config-cassonetto .finitura").show();
        $(".config-cassonetto .cod-mazzetta").show();
        $(".config-cassonetto .cod-produttore").show();
    }else{
        $(".config-cassonetto .finitura").hide();
        $(".config-cassonetto .cod-mazzetta").hide();
        $(".config-cassonetto .cod-produttore").hide();       
    }
    
    cassonetto.querySelector('.finitura span').innerHTML = finitura;
    cassonetto.querySelector('.cod-mazzetta span').innerHTML = fin_mazzetta;
    cassonetto.querySelector('.cod-produttore span').innerHTML = fin_prod;

    let maniglia = document.querySelector('.config-maniglia');
    maniglia.querySelector('.finitura span').innerHTML = config.maniglia.descrizione;

    let cerniere = document.querySelector('.config-cerniere');
    cerniere.querySelector('.finitura span').innerHTML = $(".cerniere-select").val() == "1" ?  config.cerniera.descrizione : "Invisibili"; 
}

export const setWindowFinish = async (item_id) => {

    const elements = ['finestra_profilo_1', 'finestra_profilo_2', 'cassonetto'];
    let item = finiture_finestre.pellicole_profilia.find((el)=>{return el.id == item_id; } );

    console.log(item);

    elements.forEach(async (el) => {
        let params = getMaterialParams(item, el);
        let obj = scene.getObjectByName(el);
        
        let mat = obj.material;

        const textureLoader = new THREE.TextureLoader();

        
        if(params.texture != ''){

            const loaderPromise = new Promise(function(resolve, reject) {
                function loadDone(x) {
                    resolve(x); // it went ok!
                }

                textureLoader.load(params.texture, loadDone);
            });

            let texture = await loaderPromise;
            texture.encoding = THREE.sRGBEncoding;
            mat.map = texture;



        }else{
            mat.map = null;
            //mat.needsUpdate = true;
        }

        if(params.bump_txt){

            let bumpmap = textureLoader.load(params.bump_txt);
            mat.bumpMap = bumpmap;

        }

        mat.color = new THREE.Color(params.color);
        mat.bumpScale = params.bump;
        mat.needsUpdate = true;
        obj.material = mat;

    })
}

export const cassonettoTinta = (tipo) => {

    let obj = scene.getObjectByName('cassonetto');
    const textureLoader = new THREE.TextureLoader();

    if(tipo == "1"){
        let item = config.finestra;
        obj.material.color = new THREE.Color(item.color_valore_cassonetto);

        if(item.texture_map_cassonetto != ""){
            let txt = assetDir+'textures/profili/'+item.id+'/'+item.texture_map_cassonetto;
            let texture = textureLoader.load(txt);
            texture.encoding = THREE.sRGBEncoding;
            obj.material.map = texture;
        }

        if(item.texture_bump_cassonetto != ""){
            let txt = assetDir+'textures/profili/'+item.id+'/'+item.texture_bump_cassonetto;
            let texture = textureLoader.load(txt);
            texture.encoding = THREE.sRGBEncoding;
            obj.material.bumpMap = texture;
            obj.material.bumpScale = item.bump_valore_cassonetto;
        }


    }

    if(tipo == "2"){
        let parete = scene.getObjectByName('parete');
        obj.material.map = parete.material.map;
        obj.material.bumpMap = parete.material.bumpMap;
        obj.material.color = parete.material.color;
    }    

    if(tipo == "3"){
        obj.visible = false;
    }else{
        obj.visible =  true;
    }

    obj.material.needsUpdate = true;
}

export const setHandleHingeFinish = async (item_id, type) => {

    let elements = ['cerniera_1', 'cerniera_2', 'cerniera_3', 'cerniera_4'];
    let item = finiture_finestre[type].find((el)=>{return el.id == item_id; } );
    
    elements = type == 'maniglie' ? ['maniglia'] : elements;

    let visiblity = $(".cerniere-select").val();

    elements.forEach(async (el) => {
        let obj = scene.getObjectByName(el);

        if(visiblity == "1" || type == "maniglie"){
    
            let mat = obj.material.clone();
        
            let texture_name = assetDir+'textures/'+type+'/'+item.texture_map_maniglia;
        
            if(item.texture_specular_maniglia != null){
                let specular = assetDir+'textures/'+type+'/'+item.texture_specular_maniglia;
                let specular_txt = new THREE.TextureLoader().load(specular);
                mat.specularMap = specular_txt;
                specular_txt.encoding = THREE.sRGBEncoding;
    
            }
        
            let color = item.color_valore_maniglia;
    
            mat.color = new THREE.Color(color);
            const textureLoader = new THREE.TextureLoader();
        
            if(item.texture_map_maniglia != ''){
        
                const loaderPromise = new Promise(function(resolve, reject) {
                    function loadDone(x) {
                        //console.log("loader ok");
                        resolve(x); // it went ok!
                    }
        
                    textureLoader.load(texture_name, loadDone);
                });
        
                let texture = await loaderPromise;
                texture.encoding = THREE.sRGBEncoding;
                mat.map = texture;      
        
            }else{
                mat.map = null;
                //mat.needsUpdate = true;
            }
        
            obj.visible = true;
            mat.needsUpdate = true;
            obj.material = mat;
        }else if(type == 'cerniere'){
            obj.visible = false;
        }
 
    });
   

    
}

export const setWallColor = async (color) => {
    let elements = ['parete', 'parete_laterale_3', 'parete_laterale_2', 'soffitto'];
    elements.forEach((el) => {
        let obj = scene.getObjectByName(el);
        console.log(el,obj)
        obj.material.color = new THREE.Color(color);
    });
};

export const setFloorFinish = async (item_id, type) => {

    let item = finiture_finestre.pavimenti.find((el)=>{return el.id == item_id; } );
    
    let texture_name = assetDir+'textures/pavimento/'+item.texture_map_pavimento;
    let bump_name = assetDir+'textures/pavimento/'+item.texture_bump_pavimento;
    
    let texture = null;
    let bump_texture = null;

    const textureLoader = new THREE.TextureLoader();
    

    let obj = scene.getObjectByName(type);

    if(obj != null){
        let mat = obj.material.clone();

        mat.color = new THREE.Color(item.color_valore_pavimento);

        if(item.texture_map_pavimento != ""){
            const loaderPromise = new Promise(function(resolve, reject) {
                function loadDone(x) {
                    console.log("loader ok");
                    resolve(x); 
                }
        
                textureLoader.load(texture_name, loadDone);
            });
        
            texture = await loaderPromise;
            texture.encoding = THREE.sRGBEncoding;
            mat.map = texture;  
    
        }else{
            mat.map = null;
        }

    
        if(item.texture_bump_pavimento != ""){
            bump_texture = textureLoader.load(bump_name);
            mat.bumpMap = bump_texture;
            mat.bumpScale = item.bump_valore_pavimento;
        }

        if(item.texture_specular_pavimento != null){
            let specular = assetDir+'textures/'+type+'/'+item.texture_specular_pavimento;
            let specular_txt = new THREE.TextureLoader().load(specular);
            specular_txt.encoding = THREE.sRGBEncoding;
            mat.specularMap = specular_txt;
            mat.shiness = item.shininess_valore_pavimento;
            mat.specular = new THREE.Color(item.specular_valore_pavimento); 

        }

        mat.needsUpdate = true;
        obj.material = mat;
    }

  
   
}


export const setWallFinish = async (item_id, type) => {

    let elements = ['parete', 'parete_laterale_3', 'parete_laterale_2', 'soffitto'];
    let item = finiture_finestre[type].find((el)=>{return el.id == item_id; } );
    
    let texture_name = assetDir+'textures/'+type+'/'+item.texture_map_parete;
    let bump_name = assetDir+'textures/'+type+'/'+item.texture_bump_parete;
    
    let texture = null;
    let bump_texture = null;

    const textureLoader = new THREE.TextureLoader();

    if(item.texture_map_parete != ""){
        const loaderPromise = new Promise(function(resolve, reject) {
            function loadDone(x) {
                //console.log("loader ok");
                resolve(x); 
            }
    
            textureLoader.load(texture_name, loadDone);
        });
    
        texture = await loaderPromise;
         
    }
  
    
    elements.forEach(async (el) => {
        let obj = scene.getObjectByName(el);

        if(obj != null){
            let mat = obj.material.clone();

            if(texture != null){
        
                texture.encoding = THREE.sRGBEncoding;
                mat.map = texture;  
        
            }else{
                mat.map = null;
            }
        
        
            if(item.texture_bump_parete != ""){
                bump_texture = bump_texture == null ? textureLoader.load(bump_name) : bump_texture;
                mat.bumpMap = bump_texture;
                mat.bumpScale = item.bump_valore_parete;
            }else{
                mat.bumpMap = false;
            }

            mat.needsUpdate = true;
            obj.material = mat;
        }

    });
   
}


export const initConfig = () => {

    $(".loading").css('visibility','visible');
    
    let finiture_interno = finiture_finestre.pellicole_profilia.filter((el) => el.pellicola_interno == 'si');
    let finiture_profilia = finiture_finestre.pellicole_profilia.filter((el) => el.pellicola_interno != 'si');


    generateList(finiture_profilia, ".finiture-container .row", (id) => {
        config.finestra = finiture_finestre.pellicole_profilia.find((itm)=>{return itm.id == id; } );
        setWindowFinish(id);
    });

    let html = $(".finiture-container .row").html();
    html += "<hr><p style='font-weight: 600;text-align:center;'>Pellicole da Interno</p>";
    $(".finiture-container .row").html(html);

    generateList(finiture_interno, ".finiture-container .row", (id) => {
        config.finestra = finiture_finestre.pellicole_profilia.find((itm)=>{return itm.id == id; } );
        setWindowFinish(id);
    }, false);

    generateList(finiture_finestre.maniglie, ".maniglie-container .row", (id) => {
        config.maniglia = finiture_finestre.maniglie.find((itm)=>{return itm.id == id; } );
        config.cerniera = finiture_finestre.cerniere.find((itm)=>{return itm.id == id; } );
        setHandleHingeFinish(id, 'maniglie');
        setHandleHingeFinish(id, 'cerniere');
    });
/*
    generateList(finiture_finestre.cerniere, ".cerniere-container .row", (id) => {
        config.cerniera = finiture_finestre.cerniere.find((itm)=>{return itm.id == id; } );
        setHandleHingeFinish(id, 'cerniere');
    });*/

    generateList(finiture_finestre.pareti, ".pareti-container .row", (id) => {
        config.pareti = finiture_finestre.pareti.find((itm)=>{return itm.id == id; } );
        setWallFinish(id, 'pareti');
    });

    generateList(finiture_finestre.pavimenti, ".pavimenti-container .row", (id) => {
        config.pavimento = finiture_finestre.pavimenti.find((itm)=>{return itm.id == id; } );
        setFloorFinish(id, 'pavimento');
    });

    $(".cassonetto-select").on('change', (el) => {
        cassonettoTinta(el.target.value)
        updateConfig();
    })
    
    $(".cerniere-select").on('change', (el) => {
        setHandleHingeFinish(config.maniglia.id, 'cerniere');
        updateConfig();
    })

    config.finestra = finiture_finestre.pellicole_profilia.find((el)=>{return el.id == 1; } );
    config.maniglia = finiture_finestre.maniglie.find((el)=>{return el.id == "M5"; } );
    config.cerniera = finiture_finestre.cerniere.find((el)=>{return el.id == "M5"; } );
    

    updateConfig();
    setTimeout(()=>{
        const pickr = Pickr.create({
            el: '.color-picker',
            theme: 'monolith',
            defaultRepresentation: 'HEX',
            useAsButton: false,
            inline: true,
            comparison: false,
            components: {
    
                // Main components
                preview: false,
                opacity: true,
                hue: true,
        
                // Input / output Options
                interaction: {
                    save: true,
                    input: true
                }
            },
            showAlways: true,
            
            i18n: {
                'btn:save': 'Applica Colore',
            }
        });

        pickr.on('save', (source, instance) => {
            //console.log('Event: "save"', source);
            //source.toHEXA()
            setWallColor(source.toHEXA().toString());
            cassonettoTinta($(".cassonetto-select").val());
            //console.log(source.toHEXA());

        })

    }, 1300)



}

export const init = (_scene, _cameraControls) => {

    scene = _scene;
    cameraControls = _cameraControls;
    setupZoomButtons(zoomable);
    setupPopover();
    setupButtons();
    $(".pareti-container input").first().click()
    $(".pavimenti-container input").first().click()

    setTimeout(()=>{

        $(".loader").fadeOut();
    },600)
    

}

export const setupPopover = () => {



    let html = $('#popover-content').html();
    $('#popover-content').empty();

    $("[data-toggle=popover]").popover({
        html: true,

        content: function() {
            return html
        }
    });


}

export const sendEmail = () => {
    let data = {};

    let txt = $(".btn-send").text();


    data.nome = $('#nome').val();
    data.cognome = $('#cognome').val();
    data.email = $('#email').val();

    data.config = config;

    $(".btn-send").attr('disabled', 'disabled');
    $(".btn-send").text("Invio in corso...");

    $.post( "./mailer/sendmail.php", data)
    .done(function( data ) {
        $(".btn-send").text("Richiesta Inviata");

        setTimeout(()=>{
            $(".btn-send").text(txt);
            $(".btn-send").removeAttr('disabled');
        },2000)
    });

}

export const setupButtons = () => {

    $(".btn-config-menu").on('click', ()=>{
        if($(".left").hasClass('show-menu')){
            $(".left").addClass('hide-menu')
            $(".left").removeClass('show-menu')
            $(".btn-config-info").fadeIn();
        }
        else{
            $(".left").addClass('show-menu')
            $(".left").removeClass('hide-menu')
            $(".btn-config-info").fadeOut();

        }
            
    });

    $(".btn-config-close").on('click', ()=> {
        $(".left").addClass('hide-menu')
        $(".left").removeClass('show-menu')
        $(".btn-config-info").fadeIn();
    });
    
    $(".btn-config-info-close").on('click', ()=> {
        $(".right").addClass('hide-info')
        $(".right").removeClass('show-info')
        $(".btn-config-menu").fadeIn();
    });

   
    $(".btn-config-info").on('click', ()=>{
        if($(".right").hasClass('show-info')){
            $(".right").addClass('hide-info')
            $(".right").removeClass('show-info')
            $(".btn-config-menu").fadeIn();
        }else{
            $(".right").addClass('show-info')
            $(".right").removeClass('hide-info')
            $(".btn-config-menu").fadeOut();
        }
    });

    $(".btn-send").on('click',()=>{
        sendEmail()
    });

    $(".btn-arredi").on('click',()=>{
        $(".btn-arredi").toggleClass('selected');
        let arredi = scene.getObjectByName('Arredi');
        arredi.visible = !arredi.visible;
    })

    $(".btn-vista").on('click',()=>{
        $(".btn-vista").toggleClass('selected');
        setTimeout(()=>{
            $(".btn-amb").on('click',()=>{
                resetZoom();
            })
            $(".btn-dett").on('click', () => {
                zoomTo(zoomable[3]);
            })
            $(".btn-cass").on('click', () => {
                zoomTo(zoomable[4]);
            })
            $(".btn-pros").on('click', () => {
                zoomTo({
                    name: 'maniglia',
                    offset: {x: 90, y:0, z: 130}
                });
            })
            $(".btn-man").on('click', () => {
                zoomTo(zoomable[0]);
            })

            $(".btn-cer1").on('click', () => {
                zoomTo(zoomable[1]);
            })

            $(".btn-cer2").on('click', () => {
                zoomTo(zoomable[2]);
            })
        }, 200)

    })

}

export const setupZoomButtons = (objects = []) => {
    objects.forEach((el)=>{
        addZoomButton(scene.getObjectByName(el.name), el.name, 'zoom-btn-container', () => {
            zoomTo(el);
        });
    })
};

export const zoomTo = (zoomable) => {
    $('.zoom-btn-clone').addClass('d-none');

    let object = scene.getObjectByName(zoomable.name).position;

    cameraControls.setLookAt(object.x+zoomable.offset.x, object.y+zoomable.offset.y, object.z + zoomable.offset.z, object.x, object.y+zoomable.offset.y, object.z, true) 
    

}

export const resetZoom = async () => {
    $('.zoom-btn-clone').removeClass('d-none');
    cameraControls.setLookAt(0, 45, 238, 0, 45,0, true)

}

export const getMaterialParams = (item, suffix) => {

    let texture = item['texture_map_'+suffix];
    let color = item['color_valore_'+suffix];
    let bump_txt = item['texture_bump_'+suffix];
    let bump = item['bump_valore_'+suffix];
    
    if(texture != ""){
        texture = assetDir+'textures/profili/'+item.id+'/'+texture;
    }

    if(bump_txt != ""){
        bump_txt = assetDir+'textures/profili/'+item.id+'/'+bump_txt;
    }


    let data = {
        texture: texture,
        color: color,
        bump_txt: bump_txt,
        bump:  bump
    };
    
    return data;
}


export const addZoomButton = (obj, name, className, callback) => {
    
    var button = $("."+className).children()[0].cloneNode(true);
    button.classList.add("btn-zoom-"+name);
    button.classList.add("zoom-btn-clone");
    $(button).find('img').css('margin-left', '25px')
    $('.center').append( button);
    //document.body.append(button);

    let h = parseInt(button.style.height.replace("px",""));


    $(".btn-zoom-"+name).on('click',()=>{
        $(".zoom-btn").removeClass('selected');
        $(".btn-zoom-"+name).addClass('selected');
        callback(obj);
    });

    button.style.marginTop = "-"+((h/2) + 20)+"px";
    zoomButtons.push({
        object: obj,
        button: button
    });

   // console.log(zoomButtons)
}

export const updateButtonPosition = (renderer, camera) => {
        
    zoomButtons.forEach((btn) => {
        if(btn.object != null){

            const tempV = new THREE.Vector3();
            let obj = btn.object;
            if(obj){
                obj.updateWorldMatrix(true, false);
                obj.getWorldPosition(tempV);
                tempV.project(camera);

                
                // convert the normalized position to CSS coordinates
                const x = (tempV.x *  .5 + .5) * renderer.domElement.clientWidth;
                const y = (tempV.y * -.5 + .5) * renderer.domElement.clientHeight;

                // move the elem to that position
                btn.button.style.transform = `translate(-50%, -50%) translate(${x}px,${y}px)`;
            }
            

        }
    });
}